module.exports = __webpack_public_path__ + "img/qris_payment.52be1ea6.png";